module.exports = __webpack_public_path__ + "img/in-up.9447dd96.svg";